<div *ngIf="title?.length > 0" class="mb-3" style="vertical-align:middle; line-height: 15px;">
  <span class="caption" style="color: #5E6980;">{{title}}
    
    <span *ngIf="tooltipEnabled" class="tooltip-parent">
      <beaconstac-tooltip
        elementClass="fal fa-info-circle"
        content="{{tooltipContent}}"
        tooltipPosition="top"
        caretPosition="center"
      ></beaconstac-tooltip>
    </span>

  </span>
  <span *ngIf="displayCounts" class="caption ml-3"
        [ngClass]="isSingleColor ? '' : ((current/total) * 100 === 100) ? 'text-danger' : ''"
        style="color: #C0C5CB;">{{current + '/' + total}}</span>

  <span *ngIf="isActionButtonVisible" class="float-right">
    <beaconstac-button [label]="actionButtonLabel" (onClick)="onActionButtonClicked.emit()"
                       [style]="'text'"></beaconstac-button>
  </span>
</div>
<div class="progress">
  <div class="progress-bar" role="progressbar" [ngClass]="disabled ? 'progress-bar-disabled' : ''"
       [ngClass]="isSingleColor ? 'progress-bar-primary' : (current/total) * 100 < primaryThreshold ? 'progress-bar-primary' :
       ((current/total) * 100 < warningThreshold) ? 'progress-bar-warning' : 'progress-bar-danger'"
       [ngStyle]="(current/total)*100 < 100 ? {'width': (current/total)*100 + '%', 'background': singleColorValue} : { 'width': 100 + '%', 'background': singleColorValue }"
       aria-valuemin="0" aria-valuemax="100"></div>
</div>
